import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c03995"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section__padding" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("All Orders")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Show Inactive Orders")
const _hoisted_4 = { id: "grid-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-item" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Period"),
    /*#__PURE__*/_createElementVNode("div", null, "Amount"),
    /*#__PURE__*/_createElementVNode("div", null, "Price"),
    /*#__PURE__*/_createElementVNode("div", null, "Regulation"),
    /*#__PURE__*/_createElementVNode("div", null, "Created"),
    /*#__PURE__*/_createElementVNode("div", null, "Status"),
    /*#__PURE__*/_createElementVNode("div", null, "Actions")
  ])
], -1))
const _hoisted_6 = { class: "content-row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "form" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { style: {"text-overflow":"clip"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_buy_order_form_component = _resolveComponent("buy-order-form-component")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_text, { style: {"font-size":"1.5rem"} }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_toggle, {
                  slot: "start",
                  modelValue: _ctx.showInactive,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showInactive) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBuyOrders, (order, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "content-item",
                    key: index
                  }, [
                    (_ctx.edit === order.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_buy_order_form_component, {
                              class: "test",
                              edit: true,
                              formData: order,
                              onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit = ''))
                            }, null, 8, ["formData"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_ctx.Helpers.formatDate(order.periodFrom)) + " ", 1),
                            _hoisted_10,
                            _createTextVNode(_toDisplayString(_ctx.Helpers.formatDate(order.periodTo)), 1)
                          ]),
                          _createElementVNode("div", null, _toDisplayString(order.quantity * 1000) + " KW/h", 1),
                          _createElementVNode("div", null, _toDisplayString(order.unitPrice) + " NOK", 1),
                          _createElementVNode("div", null, _toDisplayString(order.regulationType), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.Helpers.formatDate(order.created)), 1),
                          _createElementVNode("div", {
                            style: _normalizeStyle(order.status == 'Completed' ? 'color: rgb(182, 55, 55)' : 'color: green')
                          }, _toDisplayString(order.completionType ? order.completionType : order.status), 5),
                          _createElementVNode("div", _hoisted_11, [
                            (order.status == 'Active')
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  disabled: new Date(order.periodFrom) - Date.now() < 60 * 60 * 1000,
                                  fill: "clear",
                                  size: "small",
                                  onClick: _withModifiers(($event: any) => (_ctx.edit = order.id), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      color: "warning",
                                      icon: _ctx.createOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"]))
                              : _createCommentVNode("", true),
                            (order.status == 'Active')
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  fill: "clear",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.deleteBuyOrder(order.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      color: "danger",
                                      icon: _ctx.trashOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}